import React from 'react'
import styled from '@emotion/styled'

import {Alert} from '@vio/atlas/Alert'
import {ButtonLink} from '@vio/atlas/ButtonLink'
import {Icon} from '@vio/atlas/Icon'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

import {
  DEAL_FREEZE_EDUCATION_BANNER_COMPONENT,
  DEAL_FREEZE_EDUCATION_BANNER_CTA
} from './constants'

const InlineButtonLink = styled(ButtonLink)`
  &&& {
    padding: 0;
    min-height: 0;
  }
`

interface Props {
  onCtaClick: () => void
  onClose?: () => void
}

export const DealFreezeEducationBannerContent: React.FC<Props> = ({
  onCtaClick,
  onClose
}) => (
  <Alert
    icon={<Icon name="Ice" size="sm" />}
    title={
      <FormattedMessageWrapper
        id="dealFreeze.educationBannerTitle"
        defaultMessage="Not ready to commit?"
      />
    }
    onClose={onClose}
    dataId={DEAL_FREEZE_EDUCATION_BANNER_COMPONENT}
  >
    <FormattedMessageWrapper
      id="dealFreeze.educationBannerDescription"
      defaultMessage="Deal Freeze guarantees the room and price - no payment, no card details. Book when you're ready."
    />{' '}
    <InlineButtonLink
      isCompact
      isBold={false}
      onClick={event => {
        event.preventDefault()
        onCtaClick()
      }}
      dataId={DEAL_FREEZE_EDUCATION_BANNER_CTA}
    >
      <FormattedMessageWrapper
        id="dealFreeze.educationBannerCta"
        defaultMessage="See freezable deals"
      />
    </InlineButtonLink>
  </Alert>
)
